import {
    SET_VALIDATION_ERRORS,
    CHANGE_FILTER_VALUE,
    RESET_PAGE,
    CHANGE_DATA_TABLE_OPTIONS,
    FULLFILL_PATIENTS,
    FULLFILL_PATIENT
} from '../mutations/available'
import moduleApi from '../api'
import {extractUserErrorMessage, extractValidationErrors} from '@/helpers/api'
import NotificationService from '@/services/notificationService'
import _ from 'lodash'

export const changePatientFilters = ({dispatch, commit}, {filterName, value}) => {
    commit(CHANGE_FILTER_VALUE, {
        filterName: filterName,
        value: value
    })

    dispatch('resetPatientsPage')
    dispatch('getPatients')
}

export const changeDataTableOptions = ({dispatch, commit}, options) => {
    commit(CHANGE_DATA_TABLE_OPTIONS, options)
    dispatch('getPatients')
}

export const resetPatientsPage = ({commit}) => {
    commit(RESET_PAGE)
}

export const getPatientOrFetch = async ({getters, dispatch, commit}, patientId) => {
    let existingPatient = getters.patientsById[patientId]

    if (existingPatient) {
        return existingPatient
    }

    try {
        const response = await moduleApi.get(patientId)
        commit(FULLFILL_PATIENT, response.patient)

        return response.patient
    } catch (e) {
        NotificationService.error(`Unable to get patient. Try again later`)
    }

    return null
}

export const getPatients = async ({state, dispatch, commit, rootGetters}) => {
    if (rootGetters.progress('patients.getPatients')) {
        return
    }

    dispatch('startProgress', 'patients.getPatients', {
        root: true
    })

    const {page, itemsPerPage, sortBy, sortDesc} = state.dataTableOptions

    const singleSortBy = _.get(sortBy, 0, 'name')
    const singleSortDesc = _.get(sortDesc, 0, false)
    let order = null

    if (singleSortBy !== null) {
        order = 'ASC'

        if (singleSortDesc) {
            order = 'DESC'
        }
    }

    try {
        let resultFilters = {
            ...state.filters,
        }

        let result = await moduleApi.getPatients((page - 1) * itemsPerPage, itemsPerPage, resultFilters, singleSortBy, order)
        commit(FULLFILL_PATIENTS, {
            items: result.items,
            totalCount: result.totalCount
        })
    } catch (e) {
        NotificationService.error(`Unable to get patients. Try again later`)
    }

    dispatch('stopProgress', 'patients.getPatients', {
        root: true
    })
}

export const updatePatient = async ({state, dispatch, commit, rootGetters}, patientData) => {
    if (rootGetters.progress('patients.updatePatient')) {
        return
    }

    dispatch('startProgress', 'patients.updatePatient', {
        root: true
    })

    commit(SET_VALIDATION_ERRORS, {
        context: 'updatePatient',
        value: {}
    })

    let updatedPatient = null
    try {
        updatedPatient = await moduleApi.update(patientData)
        NotificationService.success(`Patient '${patientData.name} was successfully updated'`)
    } catch (e) {
        const validationErrors = extractValidationErrors(e)

        if (validationErrors) {
            commit(SET_VALIDATION_ERRORS, {
                context: 'updatePatient',
                value: validationErrors
            })
        } else {
            NotificationService.error(`Unable to update patient. Try again later`)
        }
    } finally {
        dispatch('stopProgress', 'patients.updatePatient', {
            root: true
        })
    }

    return updatedPatient
}

export const deletePatient = async ({state, dispatch, commit, rootGetters}, patientData) => {
    if (rootGetters.progress('patients.deletePatient')) {
        return
    }

    dispatch('startProgress', 'patients.deletePatient', {
        root: true
    })

    let deleteSuccess = false

    try {
        await moduleApi.delete(patientData.id)
        NotificationService.success(`Patient '${patientData.name} was successfully updated'`)
        deleteSuccess = true
    } catch (e) {
        NotificationService.error(extractUserErrorMessage(e, `Unable to delete patient. Try again later`))
    } finally {
        dispatch('stopProgress', 'patients.deletePatient', {
            root: true
        })
    }

    return deleteSuccess
}